export default function useMarketingTags() {
  function initFacebookPixel(pixelId) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    !(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
      return undefined;
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    // @ts-ignore
    fbq("init", pixelId);
    // @ts-ignore
    fbq("track", "PageView");
    return true;
  }
  const initGoogleAnalytics = (crossDomainGA, googleAnalytics) => {
    if (googleAnalytics) {
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalytics}`;
      script.async = true;
      document.head.appendChild(script);

      let script2 = document.createElement("script");
      script2.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
    
      gtag('config', '${googleAnalytics}'${
        crossDomainGA
          ? `, {
          'linker': {
            'domains': ['${crossDomainGA}'],
            'accept_incoming': true
          }
        }`
          : ""
      });
      window.gclidPromise = new Promise(resolve => {
        gtag('get', '${googleAnalytics}', 'client_id', resolve)
      });
      `;
      document.head.appendChild(script2);
    }

    return true;
  };

  const initGoogleTagManager = googleTagManagerId => {
    const script = document.createElement("script");
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${googleTagManagerId}');`;
    document.head.appendChild(script);
    const script2 = document.createElement("noscript");
    script2.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(script2);
  };
  return { initGoogleAnalytics, initFacebookPixel, initGoogleTagManager };
}
